<template>
  <form
    ref="form"
    @submit.prevent="handleSubmit"
  >
    <slot />
  </form>
</template>

<script>
export default {
    name: 'HYForm',
    props: {
        value: {
            type: Object,
            required: true,
        },
        showEmptyFields: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            observers: {},
            formUpdates: {},
        };
    },
    mounted() {
        this.createMutationObserver();
    },
    beforeDestroy() {
        this.destroyMutationObserver();
    },
    methods: {
        createMutationObserver() {
            if (!this.$slots.default) {
                return;
            }

            this.$slots.default.forEach((slot) => {
                if (!slot.componentOptions) {
                    return;
                }

                const slotId = slot.componentOptions.propsData.id;

                if (this.formUpdates[slotId]) {
                    return;
                }

                const componentInput = slot.elm.childNodes[1];

                this.observers[slotId] = new MutationObserver((mutations) => this.mutationCallback(mutations, slotId));

                if (componentInput) {
                    this.observeNode(slotId, componentInput);
                    this.formUpdates[slotId] = null;
                }
            });
        },
        destroyMutationObserver() {
            Object.keys(this.observers).forEach((slotId) => {
                this.observers[slotId].disconnect();
            });
        },
        mutationCallback(mutations, slotId) {
            const value = mutations[0].target.value;

            if (!value && !this.showEmptyFields) {
                delete this.formUpdates[slotId];
                this.$emit('input', this.formUpdates);
                return;
            }

            this.formUpdates[slotId] = value;
            this.$emit('input', this.formUpdates);
            this.$emit('changed');
        },
        observeNode(slotId, node) {
            this.observers[slotId].observe(node, {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true,
            });
        },
        handleSubmit() {
            this.$emit('submit');
        },
    },
};
</script>
